import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrmLeadsFieldService {

  appCore ='';

  constructor(private http: HttpClient) {
    this.appCore = environment.baseUrl + "LionO360ApplicationLionOCoreAPI/LionO360/2.0/API/";
   }

  getAllAccountTypes(groupId) {
    return this.http.get<any>(`${environment.coreUrl}Type?groupId=${groupId}`)
  }

  getAllSources(companyID: number) {
    return this.http.get<any>(environment.apiUrl + 'Source', {
      params: new HttpParams().append("companyId", companyID.toString())
    })
  }

  getAllRatings() {
    return this.http.get<any>(this.appCore + 'Rating')
  }

  getTimezone() {
    return this.http.get<any>(`${environment.timeZoneURL}TimeZone`)
  }

  getCurrencies() {
    return this.http.get<any>(`${environment.timeZoneURL}CurrencyUnit`);
  }

  getAllEmployeesCount() {
    return this.http.get<any>(this.appCore + 'EmployeeCount')
  }

  getAllRevenues() {
    return this.http.get<any>(this.appCore + 'AnnualRevenue')
  }

  getAllOwnerships() {
    return this.http.get<any>(this.appCore + 'Ownership')
  }

  getAllIndustries() {
    return this.http.get<any>(this.appCore + 'Industry')
  }

  getAllTags() {
    return this.http.get<any>(`${environment.apiUrlNew}Tag/All`);
  }

  addTags(tag) {
    return this.http.post<any>(environment.apiUrlNew + 'Tag', tag);
  }

  editTags(tag) {
    return this.http.put<any>(environment.apiUrlNew + 'Tag', tag);
  }

  deleteTags(id) {
    return this.http.delete<any>(environment.apiUrlNew + `Tag/${id}`);
  }

}

